import React from 'react';
import DataStateNotice from './DataStateNotice';

/** A result preview holds at most this many rows. */
export const RESULT_ROW_CAP = 100;

export interface ResultCapNoticeProps {
  rows: readonly unknown[];
}

/** Says the rows on screen are the first 100 only. Shown at 100 rows or more, never below. */
const ResultCapNotice: React.FC<ResultCapNoticeProps> = ({ rows }) =>
  rows.length >= RESULT_ROW_CAP ? (
    <DataStateNotice tone="info" title="Showing the first 100 rows. Totals and charts cover these rows only." />
  ) : null;

export default ResultCapNotice;
